import React from "react";

const STYLE = {
  Mottagen: { bg: "#2563EB", color: "#FFFFFF" },
  "Beställd": { bg: "#7C3AED", color: "#FFFFFF" },
  "Väntar på kund": { bg: "#F59E0B", color: "#FFFFFF" },
  Levererad: { bg: "#16A34A", color: "#FFFFFF" },
  Avbokad: { bg: "#DC2626", color: "#FFFFFF" },
};

export const SOFT_TEXT = { Mottagen:"#1D4ED8", "Beställd":"#6D28D9", "Väntar på kund":"#C2410C", Levererad:"#15803D", Avbokad:"#B91C1C" };
const SOFT_BG = { Mottagen:"#DBEAFE", "Beställd":"#EDE9FE", "Väntar på kund":"#FFEDD5", Levererad:"#DCFCE7", Avbokad:"#FEE2E2" };
export const StatusBadge = ({ status, className = "", variant = "solid" }) => {
  if (variant === "soft") return (
    <span data-testid={`status-badge-${status}`}
      className={`inline-flex flex-none items-center whitespace-nowrap ${className}`}
      style={{height:22,padding:"0 9px",borderRadius:11,fontSize:12,fontWeight:600,boxShadow:"none",backgroundColor:SOFT_BG[status] || SOFT_BG.Mottagen,color:SOFT_TEXT[status] || SOFT_TEXT.Mottagen}}>{status}</span>
  );
  const s = STYLE[status] || STYLE.Mottagen;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold tracking-wide whitespace-nowrap shadow-sm ${className}`}
      style={{ backgroundColor: s.bg, color: s.color }}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
